/*eslint-disable*/

import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'
import { installDepositResume } from '../utils/depositResume'

Vue.use(Vuex);

const store = new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
})

installDepositResume(store)
export default store



// WEBPACK FOOTER //
// ./src/common/store/index.js